import routerOptions0 from "/codebuild/output/src489166772/src/cb-admin/node_modules/.pnpm/nuxt@3.17.5_eslint@9.31.0_rollup@4.45.1_sass@1.89.2_typescript@5.8.3_vite@7.0.5/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}